import { onMessage } from 'firebase/messaging'
import { useEffect } from 'react'

import { initializeNotifications } from '../utils/initializeNotifications'
import { showForegroundPushNotification } from '../utils/showForegroundPushNotification'

export const useForegroundNotifications = (enabled: boolean) => {
  useEffect(() => {
    if (!enabled) return

    let cancelled = false
    let unsubscribe: (() => void) | undefined

    void initializeNotifications()
      .then((infrastructure) => {
        if (cancelled || infrastructure.status !== 'ready') return

        unsubscribe = onMessage(infrastructure.messaging, (message) => {
          if (!cancelled) showForegroundPushNotification(message)
        })
      })
      .catch(() => undefined)

    return () => {
      cancelled = true
      unsubscribe?.()
    }
  }, [enabled])
}
